// extracted by mini-css-extract-plugin
export default {"title":"MeetingInfoCard_title__n0N5L","text":"MeetingInfoCard_text__0J+on"};